import React from 'react';
import PropTypes from 'prop-types';
import InfoMessage from './InfoMessage';
import { formatDate } from '../ContratFunctions';

const ConsultationInt = ({ contrats, openModal }) => {
    // Vérifier que les contrats sont un tableau et contiennent des objets contrats
    if (!Array.isArray(contrats) || contrats.length === 0) {
        return <p className="text-gray-700">Aucun contrat disponible pour cette vue.</p>;
    }

    return (
        <div className="p-6 bg-white rounded-lg shadow-xl">
            <InfoMessage />
            <h2 className="px-4 py-2 mb-6 text-3xl font-semibold text-white rounded-md bg-axa-blue-400">
                Contrats Intermédiaire
            </h2>
            {/* Table des contrats */}
            <div className="overflow-hidden">
                <table className="min-w-full overflow-hidden rounded-lg shadow-md bg-gray-50">
                    <thead className="text-center text-gray-700 bg-gray-200">
                        <tr>
                            <th className="px-4 py-3">Référence</th>
                            <th className="px-4 py-3">Nom du Souscripteur</th>
                            <th className="px-4 py-3">Destination</th>
                            <th className="px-4 py-3">Date de Départ</th>
                            <th className="px-4 py-3">Date de Retour</th>
                            <th className="px-4 py-3">Voyageurs</th>
                            <th className="px-4 py-3">Tarif TTC (XFP)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contrats.map((contrat) => (
                            <tr
                                key={contrat.id}
                                className="text-center transition-all duration-150 transform border-t border-gray-200 cursor-pointer hover:bg-yellow-50 hover:shadow-lg hover:scale-105"
                                onClick={() => openModal(contrat)}
                            >
                                <td className="px-4 py-2 font-medium text-gray-700">
                                    {contrat.data.reference}
                                </td>
                                <td className="px-4 py-2 font-medium text-gray-800">
                                    {contrat.data.souscripteur.nomEpouse ? `${contrat.data.souscripteur.nom} ep ${contrat.data.souscripteur.nomEpouse}` : contrat.data.souscripteur.nom} {contrat.data.souscripteur.prenom}
                                </td>
                                <td className="px-4 py-2">
                                    {contrat.data.souscripteur.destination}
                                </td>
                                <td className="px-4 py-2">
                                    {formatDate(contrat.data.souscripteur.dateDepart)}
                                </td>
                                <td className="px-4 py-2">
                                    {formatDate(contrat.data.souscripteur.dateRetour)}
                                </td>
                                <td className="px-4 py-2">
                                    {contrat.data.personnes.length}
                                </td>
                                <td className="px-4 py-2">
                                    {contrat.data.contrat.tarif.totalTTC.toLocaleString('fr-FR', { minimumFractionDigits: 0 })} XPF
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

ConsultationInt.propTypes = {
    contrats: PropTypes.array.isRequired,
    openModal: PropTypes.func.isRequired
};

export default ConsultationInt;
